var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFire = function SvgIconFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.468 1.064a1 1 0 0 0-1.608.278l-2.767 5.812-2.79-1.855a1 1 0 0 0-1.386.28c-1.475 2.22-2.792 4.92-2.792 7.546a8.875 8.875 0 0 0 17.75 0c0-5.333-3.686-9.35-6.407-12.061m-3.065 7.99 2.647-5.56c2.448 2.575 4.825 5.74 4.825 9.631a6.875 6.875 0 1 1-13.75 0c0-1.758.789-3.716 1.922-5.595l2.9 1.928a1 1 0 0 0 1.456-.403m5.699 4.538a1 1 0 1 0-1.992-.184 3.134 3.134 0 0 1-2.544 2.794 1 1 0 0 0 .368 1.965 5.134 5.134 0 0 0 4.168-4.575",
    clipRule: "evenodd"
  })));
};
export default SvgIconFire;